export function createApiUrl(path: string) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const host = process.env.NEXT_PUBLIC_API_HOST?.trim();
  const protocol = process.env.NEXT_PUBLIC_API_PROTOCOL ?? "http";
  const port = process.env.NEXT_PUBLIC_API_PORT;

  if (!host) {
    throw new Error(
      "NEXT_PUBLIC_API_HOST is not configured. Backend API requests must use an absolute client-side URL.",
    );
  }

  const shouldShowPort =
    Boolean(port) &&
    !(
      (protocol === "https" && port === "443") ||
      (protocol === "http" && port === "80")
    );

  return `${protocol}://${host}${shouldShowPort ? `:${port}` : ""}${normalizedPath}`;
}
